export const satelliteNodeBackground = '#FFFA3E';
export const dishNodeBackground = '#00FA42';
export const switchNodeBackground = '#DC3DF9';
export const switchNodeDisabledBackground = '#b07eb9';
export const analyzerNodeBackground = '#FF9623';
export const locationNodeBackground = '#6279FA';
